import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { AuthService } from '../../core/services/auth.service';
import { ThemeService } from '../../core/services/theme.service';
import { ReviewService } from '../../core/services/review.service';

@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [CommonModule, RouterModule],
  template: `
    <aside class="sidebar">
      <!-- Brand Logo -->
      <div class="brand-area">
        <div class="brand-logo-wrap">
          <img
            src="assets/logo.png"
            alt="Shell Muze"
            class="brand-logo-img"
            [class.logo-dark-mode]="isDark"
          />
        </div>
        <span class="brand-badge">Admin Suite</span>
      </div>

      <!-- Navigation -->
      <nav class="nav-menu">
        <div class="nav-group-label">OVERVIEW</div>

        <a routerLink="/dashboard" routerLinkActive="active" class="nav-item">
          <span class="nav-icon">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <rect x="3" y="3" width="7" height="7" rx="1"/>
              <rect x="14" y="3" width="7" height="7" rx="1"/>
              <rect x="3" y="14" width="7" height="7" rx="1"/>
              <rect x="14" y="14" width="7" height="7" rx="1"/>
            </svg>
          </span>
          <span class="nav-label">Dashboard</span>
        </a>

        <a routerLink="/enquiries" routerLinkActive="active" class="nav-item">
          <span class="nav-icon">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
            </svg>
          </span>
          <span class="nav-label">Enquiries</span>
          <span class="nav-badge" *ngIf="pendingCount > 0">{{ pendingCount }}</span>
        </a>

        <a routerLink="/orders" routerLinkActive="active" class="nav-item">
          <span class="nav-icon">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <rect x="1" y="4" width="22" height="16" rx="2" ry="2"/>
              <line x1="1" y1="10" x2="23" y2="10"/>
            </svg>
          </span>
          <span class="nav-label">Orders</span>
        </a>

        <a routerLink="/reviews" routerLinkActive="active" class="nav-item">
          <span class="nav-icon">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
            </svg>
          </span>
          <span class="nav-label">Reviews</span>
          <span class="nav-badge" *ngIf="pendingReviewCount > 0">{{ pendingReviewCount }}</span>
        </a>

        <a routerLink="/coupons" routerLinkActive="active" class="nav-item">
          <span class="nav-icon">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <line x1="19" y1="5" x2="5" y2="19"></line>
              <circle cx="6.5" cy="6.5" r="2.5"></circle>
              <circle cx="17.5" cy="17.5" r="2.5"></circle>
            </svg>
          </span>
          <span class="nav-label">Coupons</span>
        </a>

        <div class="nav-group-label" style="margin-top: 12px;">CATALOG</div>

        <a routerLink="/products" routerLinkActive="active" class="nav-item">
          <span class="nav-icon">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <rect x="5" y="2" width="14" height="20" rx="2" ry="2"/>
              <line x1="12" y1="18" x2="12.01" y2="18"/>
            </svg>
          </span>
          <span class="nav-label">Products</span>
        </a>

        <a routerLink="/categories" routerLinkActive="active" class="nav-item">
          <span class="nav-icon">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M4 20h16a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.93a2 2 0 0 1-1.66-.9l-.82-1.2A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13c0 1.1.9 2 2 2Z"/>
            </svg>
          </span>
          <span class="nav-label">Categories</span>
        </a>

        <a routerLink="/subcategories" routerLinkActive="active" class="nav-item">
          <span class="nav-icon">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M4 6h16M4 12h10M4 18h7"/>
              <circle cx="18" cy="15" r="3"/>
            </svg>
          </span>
          <span class="nav-label">Sub-Categories</span>
        </a>

        <a routerLink="/collections" routerLinkActive="active" class="nav-item">
          <span class="nav-icon">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
            </svg>
          </span>
          <span class="nav-label">Collections</span>
        </a>

        <a routerLink="/brand-groups" routerLinkActive="active" class="nav-item">
          <span class="nav-icon">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
              <circle cx="9" cy="7" r="4"/>
              <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
              <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
            </svg>
          </span>
          <span class="nav-label">Brand Groups</span>
        </a>

        <a routerLink="/bulk-upload" routerLinkActive="active" class="nav-item">
          <span class="nav-icon">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <polyline points="16 16 12 12 8 16"/>
              <line x1="12" y1="12" x2="12" y2="21"/>
              <path d="M20.39 18.39A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.3"/>
            </svg>
          </span>
          <span class="nav-label">Bulk Upload</span>
        </a>

        <div class="nav-group-label" style="margin-top: 12px;">CONTENT</div>

        <a routerLink="/banners" routerLinkActive="active" class="nav-item">
          <span class="nav-icon">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <rect x="2" y="5" width="20" height="14" rx="2"/>
              <line x1="2" y1="10" x2="22" y2="10"/>
            </svg>
          </span>
          <span class="nav-label">Hero Banners</span>
        </a>

        <a routerLink="/options" routerLinkActive="active" class="nav-item">
          <span class="nav-icon">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <circle cx="12" cy="12" r="3"/>
              <path d="M12 2v2M12 20v2M4.22 4.22l1.42 1.42M18.36 18.36l1.42 1.42M2 12h2M20 12h2M4.22 19.78l1.42-1.42M18.36 5.64l1.42-1.42"/>
            </svg>
          </span>
          <span class="nav-label">Models & Materials</span>
        </a>
      </nav>

      <!-- Sidebar Footer -->
      <div class="sidebar-footer">
        <div class="user-card">
          <div class="avatar avatar-gold avatar-sm">
            {{ getUserInitials() }}
          </div>
          <div class="user-info">
            <div class="user-name">{{ currentUser?.name || 'Superadmin' }}</div>
            <div class="user-email">{{ currentUser?.email || 'admin@shellmuze.com' }}</div>
          </div>
        </div>
        <button (click)="logout()" class="logout-btn">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
            <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/>
            <polyline points="16 17 21 12 16 7"/>
            <line x1="21" y1="12" x2="9" y2="12"/>
          </svg>
          Sign Out
        </button>
      </div>
    </aside>
  `,
  styles: [`
    .sidebar {
      width: var(--sidebar-width, 260px);
      height: 100vh;
      position: fixed;
      left: 0;
      top: 0;
      background: var(--bg-sidebar);
      border-right: 1px solid var(--border-color);
      display: flex;
      flex-direction: column;
      padding: 20px 14px;
      z-index: 100;
      overflow-y: auto;
    }

    /* Brand */
    .brand-area {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 6px;
      padding: 10px 8px 20px;
      margin-bottom: 8px;
      border-bottom: 1px solid var(--border-color);
    }

    .brand-logo-wrap {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .brand-logo-img {
      width: 130px;
      height: auto;
      object-fit: contain;
      transition: filter var(--transition-base);
    }

    /* Invert logo for dark mode (black logo → white) and add gold tint */
    .logo-dark-mode {
      filter: invert(1) sepia(1) saturate(1.5) hue-rotate(5deg) brightness(1.1);
    }

    .brand-badge {
      font-size: 9px;
      font-weight: 700;
      letter-spacing: 0.12em;
      text-transform: uppercase;
      color: var(--text-muted);
      margin-top: 2px;
    }

    /* Nav group label */
    .nav-group-label {
      font-size: 9.5px;
      font-weight: 700;
      text-transform: uppercase;
      letter-spacing: 0.1em;
      color: var(--text-muted);
      padding: 4px 12px;
      margin-bottom: 4px;
      margin-top: 4px;
    }

    /* Nav menu */
    .nav-menu {
      flex: 1;
      display: flex;
      flex-direction: column;
      gap: 2px;
    }

    /* Nav item */
    .nav-item {
      display: flex;
      align-items: center;
      gap: 11px;
      padding: 10px 12px;
      border-radius: var(--radius-md);
      color: var(--text-secondary);
      font-weight: 600;
      font-size: 13.5px;
      transition: all var(--transition-fast);
      position: relative;
      text-decoration: none;
    }

    .nav-item:hover {
      background: rgba(255, 255, 255, 0.04);
      color: var(--text-primary);
    }

    .nav-item.active {
      background: var(--accent-gold-glow);
      color: var(--accent-gold);
      box-shadow: inset 3px 0 0 var(--accent-gold);
    }

    .nav-item.active .nav-icon {
      color: var(--accent-gold);
    }

    .nav-icon {
      width: 20px;
      height: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
      color: currentColor;
    }

    .nav-label {
      flex: 1;
    }

    /* Badge for pending count */
    .nav-badge {
      background: var(--accent-gold);
      color: #0B0F17;
      font-size: 9px;
      font-weight: 800;
      padding: 2px 6px;
      border-radius: var(--radius-full);
      min-width: 18px;
      text-align: center;
    }

    /* Footer */
    .sidebar-footer {
      padding-top: 16px;
      border-top: 1px solid var(--border-color);
      display: flex;
      flex-direction: column;
      gap: 10px;
    }

    .user-card {
      display: flex;
      align-items: center;
      gap: 10px;
      padding: 8px 10px;
      border-radius: var(--radius-md);
      background: rgba(255, 255, 255, 0.02);
      border: 1px solid var(--border-subtle);
    }

    .user-info {
      overflow: hidden;
      flex: 1;
      min-width: 0;
    }

    .user-name {
      font-size: 12.5px;
      font-weight: 700;
      color: var(--text-primary);
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .user-email {
      font-size: 10.5px;
      color: var(--text-muted);
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .logout-btn {
      width: 100%;
      background: transparent;
      color: var(--text-muted);
      border: 1px solid var(--border-color);
      border-radius: var(--radius-md);
      padding: 9px 14px;
      font-family: var(--font-sans);
      font-size: 12.5px;
      font-weight: 600;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 8px;
      transition: all var(--transition-fast);
    }

    .logout-btn:hover {
      background: var(--danger-bg);
      color: var(--danger);
      border-color: rgba(248, 113, 113, 0.25);
    }
  `]
})
export class SidebarComponent implements OnInit {
  pendingCount = 0;
  pendingReviewCount = 0;

  constructor(
    private authService: AuthService,
    private themeService: ThemeService,
    private reviewService: ReviewService
  ) {}

  ngOnInit(): void {
    this.loadPendingReviews();
  }

  loadPendingReviews(): void {
    if (this.currentUser) {
      this.reviewService.getAdminReviews('pending', '', 1, 1).subscribe({
        next: (res) => {
          this.pendingReviewCount = res.stats?.pendingCount || 0;
        },
        error: () => {
          this.pendingReviewCount = 0;
        }
      });
    }
  }

  get isDark(): boolean {
    return this.themeService.isDark;
  }

  get currentUser() {
    return this.authService.currentUserValue;
  }

  getUserInitials(): string {
    const name = this.currentUser?.name || 'Superadmin';
    return name.split(' ').map((n: string) => n[0]).join('').substring(0, 2).toUpperCase();
  }

  logout() {
    this.authService.logout();
    window.location.href = '/login';
  }
}
